<template>
    <div class="content-block">
        <div class="container">
            <div class="row">
                <div class="col">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
};
</script>


<style lang="scss" scoped>


  /*------------------------------------*\
      #PRIMARY COLOURS
  \*------------------------------------*/
  @import '../styles/colors';

  /*------------------------------------*\
      #Mixins
  \*------------------------------------*/

  /*------------------------------------
  #MEDIA SCREENS < 768px (#MOBILE FIRST)
  \*------------------------------------*/
  .content-block {
    padding: 2rem 0;

    /**
    * Elements
    */
    &__header {
      margin-bottom: 1rem;
      font-weight: 700;

      //Mods
      &--red {
        color: $red;
      }
      &__header-2 {
      margin-bottom: 1rem;
      font-weight: 400;

      //Mods
      &--red {
        color: $red;
      }
      }

    }

    &__img {
      //   display: block;
      margin: 0rem auto 2rem;

      //make fw on mobile
      position: relative;
      width: 100vw;
      left: 50%;
      margin-left: -50vw;
    }

    &__icon-list {
      text-align: center;
      padding: 0rem 2rem 1rem;
    }

    &__icon {
      display: block;
      margin: 0rem auto 2rem;
      max-width: 96px;
    }

    &__document {
      display: block;
      margin: 2rem auto;
      max-width: 300px;
    }

    &__img-thumb {
      display: block;
      margin: 2rem auto;
      max-width: 80%;
      background: transparent;
      border:none;
      position: relative;
    }

    &__modal-thumb {
      display: block;
      margin: 2rem auto;
      max-width: 300px;
      background: transparent;
      border:none;
      position: relative;
      cursor: pointer;

      &::after {
          position: absolute;
          bottom: -20px;
          right: -40px;
          content: url("../assets/img/_nav/expend-icon-org.png");
      }
    }

    /**
    * Modifiers
    */
    &--red {
      color: $dark-red;

      .content-block__header {
        color: $dark-red;
      }
    }
  }

  /*------------------------------------*\
      #MEDIA SCREENS > 767px (TABLETS)
  \*------------------------------------*/
  @media (min-width:767px) {
    .content-block {
      &__img {
        display: block;
        margin: 0rem auto 2rem;

        //make fw on mobile
        position: relative;
        left: auto;
        margin-left: auto;
        width: 100%;
      }
    }
  }

  /*------------------------------------*\
      #MEDIA SCREENS > 992px
      (LAPTOP, TABLET)
  \*------------------------------------*/
  @media (min-width:992px) {

  }

  /*------------------------------------*\
      #MEDIA SCREENS > 1200px (DESKTOP)
  \*------------------------------------*/
  @media (min-width:1200px) {

  }

  /*------------------------------------*\
      #MEDIA SCREENS > 1320px (DESKTOP)
  \*------------------------------------*/
  @media (min-width:1320px) {

  }

  /*------------------------------------*\
      #MEDIA SCREENS > 1600px (DESKTOP)
  \*------------------------------------*/
  @media (min-width:1600px) {

  }
</style>
